export default "__VITE_ASSET__CQTNU406__"